import { useTranslation } from "react-i18next";
import { AppInfo } from "../../utils/app-info";
import clsx from "clsx";
import { icAsset } from "../image/image-src";
export const Kakao = () => {
  const { t } = useTranslation();

  const href = AppInfo.get("kakao");
  if (!href) {
    return null;
  }
  return (
    <div
      className={clsx("fixed bottom-20 right-4 z-40 sm:right-10 lg:bottom-10", {
        "bottom-[110px]": [
          "/tickets/",
          "/musicals/",
          "/guide-tours/",
          "/pass/",
          "/e-sims/",
        ].some((x) => window.location.pathname?.startsWith(x)),
      })}
    >
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 rounded-full bg-[#FEE500] px-3 py-2 sm:min-w-[7.75rem] sm:px-4 sm:py-[0.9063rem]"
      >
        <img
          className="size-4"
          src={icAsset("../../assets/icons/chat.svg")}
          alt=""
        />

        <div className="text-sm font-bold sm:text-[1.125rem] sm:leading-[1.5525rem]">
          {t("Chat")}
        </div>
      </a>
    </div>
  );
};

// import { useEffect } from "react";

// declare global {
//   interface Window {
//     Kakao: any;
//   }
// }

// const jsKey = process.env.REACT_APP_KAKAO_CHANNEL_JAVASCRIPT_KEY;

// export const Kakao = ({ title = "chat" }: { title?: "chat" | "consult" }) => {
//   useEffect(() => {
//     const loadKakaoSdk = () => {
//       if (window.Kakao && window.Kakao.isInitialized?.()) {
//         console.log("Kakao already initialized");
//         createButton();
//         return;
//       }

//       const script = document.createElement("script");
//       script.src = "https://developers.kakao.com/sdk/js/kakao.min.js";
//       script.onload = () => {
//         console.log("Kakao script loaded");
//         if (!window.Kakao?.isInitialized?.()) {
//           console.log("Initializing Kakao with key:", jsKey);
//           window.Kakao.init(jsKey);
//         }
//         createButton();
//       };
//       document.head.appendChild(script);
//     };

//     const createButton = () => {
//       console.log("Creating Kakao chat button", { channelPublicId, title });
//       if (window.Kakao?.Channel?.createChatButton) {
//         window.Kakao.Channel.createChatButton({
//           container: "#kakao-channel-button",
//           channelPublicId,
//           // title,
//         });
//       } else {
//         console.error("Kakao.Channel.createChatButton is not available.");
//       }
//     };

//     loadKakaoSdk();
//   }, [title]);

//   return <div id="kakao-channel-button" />;
// };
